// The shipping temperature windows, as the customer reads them.
//
// ⚠️ A DECLARED PORT of frogger1/frogger/store/utils/weather_thresholds.py
// (the `naming.js` precedent): the backend decides which dates and which
// delivery methods are safe from those constants, and the copy a customer
// reads must quote the same numbers. `__tests__/shippingTemperatures.test.js`
// reads the Python file and fails if the two disagree.
//
//   home delivery — RESIDENTIAL_COLD_THRESHOLD .. the strictest
//                   RESIDENTIAL_HOT_THRESHOLD_* leg (min over the three)
//   hub pickup    — HUB_COLD_THRESHOLD .. HUB_HOT_THRESHOLD
//
// Fix batch 42 (operator, 2026-10-09): the checkout and confirmation pages
// told a customer who chose FedEx Hub Pickup that "Residential deliveries
// require 40–85°F". The copy names the method the customer CHOSE.
import { computeDeliveryDisplay } from '../utils/deliveryHelpers';

export const HOME_DELIVERY_TEMP_F = Object.freeze({ min: 40, max: 85 });
export const HUB_PICKUP_TEMP_F = Object.freeze({ min: 30, max: 92 });

export const DELIVERY_HUB = 'hub';
export const DELIVERY_HOME = 'home';

const range = ({ min, max }) => `${min}–${max}°F`;

export const HUB_TEMPERATURE_LINE =
  `FedEx Hub Pickup allows ${range(HUB_PICKUP_TEMP_F)} along the route; the box stays indoors until you collect it.`;
export const HOME_TEMPERATURE_LINE =
  `Home delivery needs ${range(HOME_DELIVERY_TEMP_F)} at every point on the route.`;

// The method of a placed order, read the way the confirmation page's own
// "Shipping Method" line reads it: the serializer's shipping_summary first
// (it is derived from Order.delivery_type), then the one delivery helper.
// Anything unreadable answers null, and the notice then shows both windows
// rather than guessing one.
export const deliveryMethodOfOrder = (order) => {
  if (!order || typeof order !== 'object') return null;
  const destinationType = order.shipping_summary?.destination_type;
  if (destinationType === 'pickup') return DELIVERY_HUB;
  if (destinationType === 'delivery') return DELIVERY_HOME;
  if (!order.delivery_type && !order.delivery_type_label
      && !order.delivery_type_display && order.is_residential == null) {
    return null;
  }
  return computeDeliveryDisplay(order).label.includes('Hub') ? DELIVERY_HUB : DELIVERY_HOME;
};
